/* eslint-disable jira/filename-case */
export const RESOURCE_TYPE_ORGANIZATION_PANEL_FORGE_DATA = 'ORGANIZATION_PANEL_FORGE_DATA';
